import { render, staticRenderFns } from "./AddUpdateThread.vue?vue&type=template&id=c181922e&"
import script from "./AddUpdateThread.vue?vue&type=script&lang=js&"
export * from "./AddUpdateThread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports